import React from 'react';

export interface JoinProps {
  with: React.ReactNode;
  children: React.ReactNode;
  append?: boolean;
}

const Join: React.FC<JoinProps> = React.memo(function Join({
  with: withElement,
  children,
  append,
}) {
  const childrenArray = React.useMemo(() => {
    return React.Children.toArray(children).filter((child: unknown) => {
      // Filter out "null" or boolean children
      if (!child) {
        return false;
      }

      return true;
    });
  }, [children]);
  const childrenLength = childrenArray.length - 1;

  return (
    <React.Fragment>
      {childrenArray.map((child, idx) => {
        return (
          <React.Fragment key={idx}>
            {child}
            {childrenLength !== idx && withElement}
            {childrenLength === idx && append && withElement}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
});

export default Join;
